// Library used to autosize inputs to whatever character length they are at.
import { plugin } from 'vue-input-autowidth'

export default defineNuxtPlugin(nuxtApp =>
  nuxtApp.vueApp.use(plugin)
)

